var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInbox = function SvgInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m6 13 1.995-2.395c.637-.763.955-1.145 1.338-1.145s.702.382 1.338 1.145l.658.79c.636.763.954 1.145 1.338 1.145.383 0 .701-.382 1.338-1.145L16 9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11c0 1.379.28 2.693.784 3.888.279.66.418.99.436 1.24.017.25-.057.524-.204 1.073L1 21l3.799-1.016c.549-.147.823-.22 1.073-.204.25.018.58.157 1.24.436A10 10 0 0 0 11 21Z"
  })));
};
export default SvgInbox;